import { create } from "zustand";
import { persist } from "zustand/middleware";

const initialState = null;

export const useUserStore = create(
  persist(
    (set, get) => ({
      user: null,
      setUser: (item) =>
        set((state) => ({
          user: item,
        })),
      // removeUser: () =>
      //   set((state) => ({
      //     user: initialState,
      //   })),
      reset: () => set(initialState),
    }),
    {
      name: "userStore",
      //   storage: createJSONStorage(() => SecureStorage),
    }
  )
);
